import { WorkflowStepEditor } from "../../../workflows/routes/WorkflowEditor/StepEditor";
import { CircularLoader, Drawer } from "@introist/react-foundation/v2";
import { useCallback, useState } from "react";
import { WorkflowStep } from "../../hooks/useWorkflowSteps";
import { api } from "../../../../services/rpc/RpcProvider";

export type StepEditorMode = "workflow" | "nudge" | "template";

type WorkflowStepEditorDrawerProps = {
  open: boolean;
  onClose: () => void;
  workflowId: string;
  step: WorkflowStep;
  mode?: StepEditorMode;
};

export const WorkflowStepEditorDrawer = ({
  open,
  onClose,
  workflowId,
  step,
  mode = "workflow"
}: WorkflowStepEditorDrawerProps) => {
  const [hasChanges, setHasChanges] = useState(false);

  const { data: options } = api.workflows.v4.steps.options.useQuery(
    {
      stepType: step?.stepType
    },
    { enabled: !!step }
  );

  const close = useCallback(
    (force?: boolean) => {
      if (!hasChanges || mode === "template") onClose();
      else if (force === true) onClose();
    },
    [hasChanges, onClose, mode]
  );

  const waitForOptions = options === undefined;

  return (
    <Drawer open={open} width="540px" onClose={close}>
      {open && waitForOptions && <CircularLoader fillParent />}
      {open && step && !waitForOptions && (
        <WorkflowStepEditor
          workflowId={workflowId}
          workflowStep={step}
          onEditStateChanged={setHasChanges}
          onClose={close}
          mode={mode}
        />
      )}
    </Drawer>
  );
};
